
import React from 'react'

function FromFieldNumber(props) {
  
  return (
    <div className="row">
        <div className="label col-6" > 
            <label> {props.label} <span className="star error"> {props.star} </span></label>
             
        </div>
        <div className="col-md-6" > 
            <input type="number" 
                className="form-control" 
                placeholder={props.placeholder} 
                value={props.inputValue}
                onChange={ (event)=>props.setInputValue( (/^[0-9. ]+$/.test(event.target.value) )? event.target.value.slice(0,14):'' ) } 
                //onBlur={(event)=>props.checkInputValue(event.target.value)}
                readOnly={props.readOnly}
                
                />
          <span className="invalid-feedback"> {props.setErrorMsg} </span>
        </div>
    </div>
  )
}

export default FromFieldNumber